<template>
  <div class="mod-inspection site-wrapper">
    <div class="guide">
      <span>您的位置：</span>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/order' }"> 我的订单 </el-breadcrumb-item>
        <el-breadcrumb-item>订单详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main" v-if="!successPage" v-loading="stepLoadding">
      <div class="mod-title" v-if="steps.childrenList.length > 0">
        <h1>{{ steps.stepName }}</h1>
        <span class="under-line"></span>
      </div>
      <div>
        <el-steps :active="active" align-center finish-status="success" style="width: 556px;margin: 52px auto 33px;">
          <el-step :title="step.stepName" v-for="(step, index) of steps.childrenList" :key="index"> </el-step>
        </el-steps>
        <div class="step_content">
          <template v-for="(mod, idx) of pageInfo">
            <div class="moudlePanle" :key="idx">
              <div style="position: relative;display: flex;">
                <el-divider content-position="left">{{ mod.moduleName }} </el-divider>
                <div class="btncontrol" v-if="mod.layout === 'TABLE' && mod.moduleNameEn === 'goods'">
                  <el-button type="danger" round size="small" :disabled="dataListSelections.length <= 0" @click="ypDeleteHandle">删除</el-button>
                  <el-button round size="small" @click="ypAddHandle('1')">添加</el-button>
                  <el-button round :disabled="dataListSelections.length!=1" size="small" @click="copyRow">复制</el-button>
                </div>
              </div>

              <div v-if="mod.layout === 'TABLE'">
                <el-table :data="mod.data" :key="active" @selection-change="selectionChangeHandle" style="width: 100%">
                  <el-table-column type="selection" header-align="center" align="center" width="50">
                  </el-table-column>
                  <el-table-column type="index" label="序号" align="center" width="50"> </el-table-column>
                  <el-table-column show-overflow-tooltip :prop="col.field" :label="col.label" v-for="(col, i) of mod.header" :key="i">
                    <template slot-scope="{ row }">
                      <a v-if="col.type == 'file'" @click.prevent="downloadFile(row[col.field] && row[col.field][0] && row[col.field][0].fileDownloadUrl, row[col.field] && row[col.field][0] && row[col.field][0].fileName)">
                        {{ row[col.field] && row[col.field][0] && row[col.field][0].fileName }}
                      </a>
                      <span v-else>
                        {{ row[col.field] }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="mod.moduleNameEn === 'goods'" header-align="center" align="center" width="100" label="操作" fixed="right">
                    <template slot-scope="scope">
                      <el-button style="padding: 0;" type="text" @click="editOne(mod.header, scope.row, scope.$index)">编辑
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div v-if="mod.layout === 'FORM'" style="width: 94%;margin: 0 auto;">
                <form-template ref="formData" :mod="mod" :orderId="orderId"></form-template>
              </div>
            </div>
          </template>
        </div>
        <div class="btngroup" v-if="pageInfo.length">
          <!-- <p style="margin-bottom: 16px;font-size: 18px;color: #FF6F77;font-weight: bold;">预估总价：{{ totalPrice }}</p> -->
          <el-button class="up" round @click="upHandle" v-if="active !== 0">上一步</el-button>
          <el-button type="primary" round class="next" @click="nextHandle" v-if="steps.childrenList.length > 0 && active !== steps.childrenList.length - 1">下一步</el-button>
          <el-button type="primary" round class="next" @click="openAttention" v-if="active === steps.childrenList.length - 1">提交</el-button>
        </div>
      </div>
    </div>
    <!-- 送检成功 -->
    <div class="main" v-if="successPage">
      <el-result icon="success" title="提交成功">
        <template slot="subTitle">
          <p>您好！你已经成功提交了检测服务相关信息。<br />请注意查收订单检测状态。</p>
        </template>
        <template slot="extra">
          <button class="diy_button primary_button" @click="$router.push({ name: 'order' })">{{ backOrder }}s后返回我的订单</button>
        </template>
      </el-result>
    </div>
    <!-- 样品编辑 -->
    <yp-detail v-if="ypDetailPop" ref="ypDetailPop" @refreshDataList="getDetaile" @freshPrice="getExtra"></yp-detail>
    <!-- 手动添加样品 -->
    <yp-add v-if="ypAddPop" ref="ypAddPop" @refreshDataList="getDetaile"></yp-add>
    <!-- 注意事项 -->
    <attention v-if="attentionVisible" ref="attentionVisible" @comfirmBtn="submitForm"></attention>
    <!-- 复制样品 -->
		<sample-copy v-if="sampleCopyPop" ref="sampleCopyPop" @refreshDataList="getDetaile"></sample-copy>
  </div>
</template>

<script>
import { downloadFile } from "@/utils";
import ypAdd from "./copn/ypAdd.vue";
import ypDetail from "./copn/ypDetail.vue";
import Attention from "./copn/attention.vue";
import formTemplate from "@/components/formTemplate.vue"
import sampleCopy from "@/views/order/copn/copy.vue";
export default {
  components: {
    ypAdd,
    ypDetail,
    Attention,
    formTemplate,
    sampleCopy
  },
  data() {
    return {
      stepLoadding: false,
      ypDetailPop: false,
      steps: { childrenList: [] },
      moduleIds: [],
      active: 0,
      pageInfo: [],
      dataListSelections: [],
      orderId: "",
      ypAddPop: false,
      qySelect: [],
      sampleAddHandleKey: '',//样品是否是手动添加的字段
      totalPrice: 0,
      attentionVisible: false,
      successPage: false,
      backOrder: 3,
      timer: null,
      sampleCopyPop: false
    };
  },
  created() {
    this.orderId = this.$route.query.orderId;
    // 获取送检流程
    this.getMoudle();
    // 获取开票信息
    this.$http.get(this.$api.shiroApi.tickAll).then(({ data }) => {
      this.qySelect = data.data;
    });
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    downloadFile(url, fileName) {
      downloadFile(url, fileName);
    },
    getExtra() {
      // this.$http.post(this.$api.orderApi.getOrderExtra, { orderId: this.orderId }).then(({
      //   data
      // }) => {
      //   this.totalPrice = `¥${data.data.totalValuation || '0'}`;
      // }).catch(() => {
      //   this.$message.error("获取预估总价失败！")
      // });
    },
    editOne(showConfig, row, index) {
      this.ypDetailPop = true;
      let allTable = this.pageInfo.filter(v => v.layout === 'TABLE')[0].data;
      this.$nextTick(() => {
        this.$refs.ypDetailPop.editSample(this.orderId, JSON.parse(JSON.stringify(row)), showConfig, false, this.sampleAddHandleKey, allTable, index);
      });
    },
    getMoudle() {
      this.stepLoadding = true;
      this.$http.get(this.$api.pageInfoApi.getStep, { params: { code: 'ORDER_XD' } }).then(({ data }) => {
        this.stepLoadding = false;
        this.steps = data.data;
        // 获取内容详情
        this.getDetaile();
      }).catch(() => {
        this.stepLoadding = false;
      });
    },
    getDetaile() {
      // 更新价格
      this.getExtra();
      this.stepLoadding = true;
      let params = {
        orderId: this.orderId,
        moduleIds: this.steps.childrenList[this.active].moduleIds
      };
      // 步骤表单
      this.$http.post(this.$api.orderApi.stepInfo, params).then(({ data }) => {
        this.stepLoadding = false;
        if (!data.data) {
          this.$message({
            message: data.msg,
            type: "error"
          });
          return
        }
        data.data.forEach(mod => {
          if (mod.layout === 'FORM') {
            mod.formData = {};
            // 参数初始化
            mod.list = mod.list.filter(v => v.showed == true);
            mod.formData.list = mod.list;
            mod.list.forEach(item => {
              // 展示的表单
              this.$set(mod.formData, item.field, item.val);
            })
          }
          if (mod.layout === 'TABLE') {
            // 保存“是否是手动添加”字段key
            this.sampleAddHandleKey = mod.header.filter(v => v.label == '是否是手动添加')[0].field;
            // 只展示showed = true的表头
            mod.header = mod.header.filter(v => v.showed == true)
            // 数组回显
            mod.header.forEach(v => {
              if (v.type == "checkbox") {
                mod.data.forEach(row => {
                  row[v.field] = row[v.field].join(',')
                })
              }
            })
          }
        })
        this.pageInfo = data.data;
      }).catch(() => {
        this.stepLoadding = false;
      });
    },
    // 上一步
    upHandle() {
      --this.active;
      this.getDetaile();
    },
    // 下一步
    nextHandle() {
      let isSubmit = 0;
      for (let item of this.$refs["formData"]) {
        item.$refs.formRef.validate((valid) => {
          if (valid) {
            isSubmit++;
          } else {
            return false;
          }
        });
      }
      if (isSubmit === this.$refs["formData"].length) {
        // 合并提交表单项
        let params = this.setParam();
        this.$http.post(this.$api.orderApi.updateOrder, params).then(() => {
          this.active++;
          this.getDetaile();
        });
      }
    },
    setParam() {
      let params = {
        orderId: this.orderId
      }
      for (let forms of this.$refs["formData"]) {
        params = Object.assign(params, forms.getFormData());
      }
      return params
    },
    // 打开注意事项
    openAttention() {
      this.attentionVisible = true;
      this.$nextTick(() => {
        this.$refs.attentionVisible.visible = true;
      })
    },
    // 提交
    submitForm() {
      this.stepLoadding = true;
      // 合并提交表单项
      let params = this.setParam();
      this.$http.post(this.$api.orderApi.submitOrder, params).then(() => {
        this.stepLoadding = false;
        // 打开弹窗倒计时
        this.successPage = true;
        const TIME_COUNT = 3;
        this.backOrder = TIME_COUNT;
        this.timer && clearInterval(this.timer);
        this.timer = setInterval(() => {
          if (this.backOrder > 0) {
            this.backOrder--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
            this.$router.push({ name: 'order' });
          }
        }, 1000);
      }).catch(() => {
        this.stepLoadding = false;
      });
    },
    // 表格多选
    selectionChangeHandle(val) {
      this.dataListSelections = val;
    },
    //  step1增加样品
    ypAddHandle() {
      this.ypAddPop = true;
      this.$nextTick(() => {
        this.$refs.ypAddPop.init(this.orderId);
      });
    },
    // step1 ，样品删除
    ypDeleteHandle() {
      let ids = this.dataListSelections.map((item) => {
        return item.id;
      });
      this.$confirm(`确定进行["删除"]操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          orderId: this.orderId,
          ids: ids
        };
        this.$http.post(this.$api.orderApi.delSample, params).then(({ data }) => {
          this.$message({
            message: data.msg,
            type: "success"
          });
          this.getDetaile();
        });
      });
    },
    copyRow(){
			this.sampleCopyPop = true;
			this.$nextTick(() => {
				this.$refs.sampleCopyPop.init(this.orderId,this.dataListSelections[0].id);
			});
		}
  }
};
</script>

<style lang="scss" scoped>
.mod-inspection {
  .main {
    background: #fff;
    min-height: 600px;
    padding: 32px 76px;

    .mod-title {
      h1 {
        font-size: 24px;
      }
    }

    .step_content {
      position: relative;

      .moudlePanle {
        margin-bottom: 30px;
      }

      .btncontrol {
        position: relative;
        top: 6px;
        margin-left: 15px;
        width: 235px;
      }
    }

    .btngroup {
      text-align: center;
      margin-top: 40px;

      button {
        width: 150px;
      }
    }
  }
}
</style>
